import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { GetBaseRes } from '../models/GetBaseRes'

export interface GetOwnersRes {
    id: string,
    email: string,
    name: string,
  }

export default {
    
    filter: () =>
    AxiosInstance.get<GetBaseRes[]>(`${Config.profile.bases}`),

    owner: () =>
        AxiosInstance.get<GetOwnersRes[]>(`${Config.profile.owners}/9d1ba9e1-8540-4893-895e-d8fda181f121`)
}